import { v4 } from 'uuid';

import type { SavedCashForward } from '@/domain/WorkspaceForex/savedProducts/cash/SavedCashForward.ts';
import type { FxCashForward } from '@/store/cash/state.ts';

export const mapToFxCashForward = ({ properties, clientId }: SavedCashForward): FxCashForward => {
  const [currency1, currency2] = properties.currencyPair?.split('/') ?? [undefined, undefined];

  return {
    type: 'FxFwd',
    clientId,
    properties: {
      currencyPair: properties.currencyPair ?? undefined,
      currency1,
      currency2,
      maturityDate: undefined,
      maturityDateTenor: properties.maturityDateTenor,
      notional: properties.notional,
      notionalCurrencyIndex: properties.notionalCurrencyIndex ?? 1, // default to 1 to fix issue during the migration
    },

    tradeCapture: {
      status: 'INITIALIZED',
      sessionId: v4(),
      version: -1,
    },
  };
};
